module.exports = __webpack_public_path__ + "img/20231219151239583n3r.c981b6da.jpg";